// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){
 
  //wait until images, links, fonts, stylesheets, and js is loaded
  window.addEventListener("load", function() {

    const storiesSwiper = document.querySelector('.storiesSwiper');
    if(storiesSwiper) {
      const storiesSwiperOptions = JSON.parse(storiesSwiper.getAttribute('data-swiper'));
      /* Slider initialisieren */
      const storiesSwiperInstance = new Swiper(storiesSwiper, storiesSwiperOptions);
    }

   }, false);
 
 });